import { deClientPortalNotificationSettingsConstantsPages } from './Settings/constants'
import { deClientPortalNotificationSettingsContentPages } from './Settings/NotificationSettingsContent'
import { deClientPortalUserSettingsPagePages } from './Settings/UserSettingsPage'
import { deClientPortalUserSettingsSidebarPages } from './Settings/UserSettingsSidebar'

export const deClientPortalSettingsPages = {
    settings: {
        ...deClientPortalUserSettingsPagePages.settings,
        ...deClientPortalUserSettingsSidebarPages.settings,
        ...deClientPortalNotificationSettingsContentPages.settings,
        ...deClientPortalNotificationSettingsConstantsPages.settings,
    },
}
